import { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const MemberReportsIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
      fill="none"
    >
      <line
        x1="7"
        y1="1"
        x2="7"
        y2="31"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeLinejoin="miter"
      />
      <path
        d="M2,1h22.909C26.064,1,27,1.895,27,3v26c0,1.105-0.936,2-2.091,2H2V1z"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeLinejoin="miter"
      />
      <line
        x1="31"
        y1="5"
        x2="31"
        y2="9"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeLinejoin="miter"
      />
      <line
        x1="31"
        y1="13"
        x2="31"
        y2="17"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeLinejoin="miter"
      />
      <circle
        cx="17"
        cy="12"
        r="2"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeLinejoin="miter"
      />
      <path
        d="M22,21H12v0c0-2.209,1.791-4,4-4h2C20.209,17,22,18.791,22,21L22,21z"
        stroke={color}
        strokeWidth={2.4}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeLinejoin="miter"
      />
    </svg>
  );
};

export default MemberReportsIcon;
